import { trimSlashes } from '../../../util/helpers/string'

/**
 * Creates a URL by combining a base URL and a path. Both the base URL and the path are trimmed of leading and trailing slashes.
 * Useful to prevent duplication or absence of trailing slashes
 *
 * @param {string} baseUrl - The base URL to be used in the final URL.
 * @returns {function(string): string} - A function that takes a path string and returns a formatted URL with the base URL and path.
 *
 * @example
 *
 * const createUrl = (baseUrl) => (path) => `/${trimSlashes(baseUrl)}/${trimSlashes(path)}`;
 *
 * const urlFunction = createUrl("/api/v2/");
 * console.log(urlFunction("/path/to/resource/")); // Output: "/api/v2/path/to/resource"
 * console.log(urlFunction("path/to/resource")); // Output: "/api/v2/path/to/resource"
 */
export default (baseUrl) => (path) => {
  const dinamicHash = baseUrl.includes('http') ? '' : '/'
  return `${dinamicHash}${trimSlashes(baseUrl)}/${trimSlashes(path)}`
}
